import { Controller } from "stimulus"

export default class extends Controller
  @targets: ['accountsMenu']

  toggleMenu: (event) ->
    $(@accountsMenuTarget).slideToggle
      duration: 150
